import { environmentHttpClient } from "client/Api/httpClient";

export type CommunityListItem = {
	id: number;
	name: string;
};

export function listCommunities(signal?: AbortSignal): Promise<readonly CommunityListItem[]> {
	return environmentHttpClient.get<readonly CommunityListItem[]>(
		"UiApi/Workspace/LiveInformation/Communities",
		undefined,
		{ signal }
	);
}